import { useEffect, useRef, useState } from "react";
import DataBase from "../dataBase/liquidGuides";
import { splitSharedGuides, initialSharingState, applySharingAction } from "./shareInvites";

// How many share invitations are waiting (4.10.55) — for the badge on the
// Library button. Loaded once per sign-in; SharedInvitations announces every
// change with notifySharingChanged so the badge follows Accept/Decline/Block.
// 0 when the sharing record can't be used. A person's first sign-in on this
// version sets the record up here, accepting everything already shared, so
// only guides shared after that become invitations.

const CHANGED_EVENT = "andiamo:sharing-changed";

export const notifySharingChanged = (state) => {
  if (state) latestState = state;
  window.dispatchEvent(new CustomEvent(CHANGED_EVENT, { detail: state }));
};

// The person's sharing record as last loaded or changed in this session
// (null until loaded, or when it can't be used) — so a hide made outside the
// Library (Report this Guide) refreshes the Library's lists at once, and
// Featured can leave out guides the person hid. 2026-10-29.
let latestState = null;
export const getSharingState = () => latestState;

// Saves a sharing action and tells every open screen about it.
export const sharingActionNow = (uid, action, id) => {
  DataBase.sharingAction(uid, action, id);
  if (latestState) notifySharingChanged(applySharingAction(latestState, action, id));
};

// Listen for those changes: onSharingChanged(cb) → unsubscribe fn.
export const onSharingChanged = (cb) => {
  const listener = (e) => cb(e.detail);
  window.addEventListener(CHANGED_EVENT, listener);
  return () => window.removeEventListener(CHANGED_EVENT, listener);
};

const useInvitationCount = (uid) => {
  const [count, setCount] = useState(0);
  const guidesRef = useRef([]);

  useEffect(() => {
    setCount(0);
    guidesRef.current = [];
    latestState = null;
    if (!uid || uid === "guest") return undefined;
    let alive = true;
    DataBase.getSharingState(uid, (st) => {
      if (!alive || st.pass !== true) return;
      DataBase.getAllGuideInfo(
        uid,
        (res) => {
          if (!alive || res.pass !== true) return;
          guidesRef.current = res.res;
          let state = st.res;
          if (!state || state.initialized !== true) {
            state = initialSharingState(res.res, uid);
            DataBase.setSharingState(uid, state);
          }
          latestState = state;
          setCount(splitSharedGuides(res.res, uid, state).invitations.length);
        },
        "Shared"
      );
    });
    const onChanged = (e) => {
      if (guidesRef.current.length > 0 && e.detail) setCount(splitSharedGuides(guidesRef.current, uid, e.detail).invitations.length);
    };
    window.addEventListener(CHANGED_EVENT, onChanged);
    return () => {
      alive = false;
      window.removeEventListener(CHANGED_EVENT, onChanged);
    };
  }, [uid]);

  return count;
};

export default useInvitationCount;
